module.exports = __webpack_public_path__ + "img/PICTO_LIGNE_TURQUOISE.d44b776a.svg";